module.exports = __webpack_public_path__ + "static/media/logo-grande.5b47525c.jpg";